import { rgb, PageSizes } from 'pdf-lib';
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf';
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf';

import { getHyphenedDate } from '../../utils/utils';
import { createPDFDocument, customDrawText, getFontArrayBuffer } from './pdf_create';
import { getDisplayOriginWithOther, getDisplaySize } from '../../utils/Items';

import { getListOrderDetail } from '../../http/api/OrderAPI'
import { filterPartition, getOutputDestination, getPrintPages, getProductPartitionList, hasShopOrder } from '../../utils/orderForm';
import { postMarketPriceSearchTableInfoListAPI } from '../../http/api/MarketPriceAPI';

import { getHorizontalOrderFormPageParameter, createHorizontalOrderFormHeader, createHorizontalOrderFormTableBones, createHorizontalOrderFormFooter, outputHorizontalOrderFormTableProductData } from './HorizontalOrderFormPDF';
import { getDirectorEmployee } from '../../http/api/MasterAPI';
import {stripTrailingZeros} from "../../utils/decimal";

// 注文数量の出力
const outputHorizontalOrderFormTableOrderQuantityData = (page, pageParameter, shops, rowIndex, columnIndex, outputData) => {

  const {
    margin, 
    rowHeight ,
    columnWidth ,
    shopColumnWidth,
    orderUnitColumnLeft,
    fonts,
    tableDataStart_y,
    datePartition,
    dateList
  } = pageParameter;

  const { shopOrderInfo } = outputData;

  let orderQuantityKeyList = [];

  if (datePartition) {
    orderQuantityKeyList = dateList.map((dt) => ({
      shopId: shops[0].shopId,
      orderDate: getHyphenedDate(dt)
    }));
  } else {
    orderQuantityKeyList = shops.map((shopInfo) => ({
      shopId: shopInfo.shopId,
      orderDate: null
    }))
  }

  const dataStart_x = margin + columnWidth * columnIndex
  const text_y = tableDataStart_y - rowHeight * (rowIndex + 1 / 2) - 4

  orderQuantityKeyList.forEach((orderQuantityKey, orderQuantityIndex) => {
    let orderData = shopOrderInfo.find((shopOrderData) => (
      shopOrderData.shopId === orderQuantityKey.shopId
      && (!orderQuantityKey.orderDate || shopOrderData.orderDate === orderQuantityKey.orderDate)
    ));

    if (orderData && orderData.orderQuantity >= 1) {
      let orderQuantityStr = orderData.orderQuantity.toString();

      customDrawText(page,orderQuantityStr, {
        x: dataStart_x + orderUnitColumnLeft + shopColumnWidth * (orderQuantityIndex + 1/2) - fonts.mincho_font.widthOfTextAtSize(orderQuantityStr, 12) / 2,
        y: text_y,
        size: 12,
        font: fonts.mincho_font,
        color: rgb(0, 0, 0),
      });
    }
  });
}

// 価格表１サイクル出力
const outputOrderCheckFormForACycle = (
  pdfDoc,
  marketPriceInfo,
  directorEmployeeInfo,
  priceInfoList,
  shippingDateInfo,
  pageParameter,
  outputShops
) => {
  let {width, height, rowNumber, columnNumber, shopSummary, productTypePartition, skipNoOrder, asSendingLabel} = pageParameter;

  let shopPriceInfoList
    = skipNoOrder
      ? priceInfoList.filter((priceInfo) => hasShopOrder(priceInfo, outputShops))
      : priceInfoList;

  let productPartitionList = filterPartition(shopPriceInfoList, pageParameter, rowNumber);
  // let productPartitionList = getProductPartitionList(shopPriceInfoList, productTypePartition, rowNumber);
  // console.log(productPartitionList);

  let columnCount = productPartitionList
    .map((productPartition) => Math.ceil(productPartition.length / rowNumber !== 0 ? productPartition.length / rowNumber : 1))
    .reduce((prevCnt, thisCnt) => prevCnt + thisCnt, 0);

  let pageCountACycle = Math.max(Math.ceil(columnCount / columnNumber), 1);

  // ページの生成
  let pages = Array.from(new Array(pageCountACycle)).map((_, pageIndex) => {
    let page = pdfDoc.addPage([width, height]);
    let shopInfo = outputShops[0];
    if (
      pageParameter.directorEmployeePartition &&
      productPartitionList[pageIndex * pageParameter.columnNumber]
    ) {
      const directorEmployeeId =
        productPartitionList[pageIndex * pageParameter.columnNumber][0]
          ?.directorEmployeeId;
      const directorEmployeeObj = directorEmployeeInfo.find(
        (x) => x.directorEmployeeId == directorEmployeeId
      );
      pageParameter.directorEmployee = directorEmployeeObj ? directorEmployeeObj.directorEmployeeName || "なし" : null;
    }

    createHorizontalOrderFormHeader(
      marketPriceInfo,
      page,
      getTitle(asSendingLabel),
      getOutputDestination(shopInfo, shopSummary, asSendingLabel),
      shippingDateInfo,
      pageParameter
    );
    createHorizontalOrderFormTableBones(page, pageParameter);
    createHorizontalOrderFormFooter(page, pageParameter, marketPriceInfo);
    return page;
  });

  // 表の各データ行出力
  var lastName = "";
  var lastOrigin = "";
  var lastPriceDetailTypeId = 0;

  var totalDataIndex = 0;

  productPartitionList.forEach((dataList) => {
    if (dataList.length === 0) {
      totalDataIndex = Math.ceil(totalDataIndex / rowNumber + 1) * rowNumber
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber

    dataList.forEach((data, index) => {
      let rowIndex = (totalDataIndex) % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      let displayOrigin = getDisplayOriginWithOther(data.origin, data.isOriginOther);

      let outputAsFirstOfType
        = !productTypePartition
          && (data.priceDetailTypeId !== lastPriceDetailTypeId)
          && totalDataIndex > 0;

      if (index % rowNumber === 0 || outputAsFirstOfType) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        ...data,
        name: (lastName === data.productName ? "〃" : data.productName),
        origin: (lastName === data.productName && lastOrigin === displayOrigin ? "〃" : displayOrigin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.isShortage ? "-" : data.price,
        unit: data.orderingUnit,
        outputAsFirstOfType: outputAsFirstOfType
      }
      
      outputHorizontalOrderFormTableProductData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);
      outputHorizontalOrderFormTableOrderQuantityData(pages[pageIndex], pageParameter, outputShops, rowIndex, columnIndex, outputData);

      lastName = data.productName;
      lastOrigin = displayOrigin;
      lastPriceDetailTypeId = data.priceDetailTypeId;

      totalDataIndex += 1;
    })
  })

  return pages;
}

// 価格表(横)PDF文書作成
async function createHorizontalOrderCheckFormPDFDocumentInfo(
  marketPriceInfo,
  directorEmployeeInfo,
  priceInfoList,
  shops,
  destinations,
  isSample,
  shippingDateInfo,
  pdfSetting
) {

  const pdfDoc = await createPDFDocument();
  
  const genminchoArrayBuffer = await getFontArrayBuffer(genmincho);
  const genminchoBoldArrayBuffer = await getFontArrayBuffer(genmincho_bold);
  
  //日本語フォント読込
  const mincho_font = await pdfDoc.embedFont(genminchoArrayBuffer);
  const mincho_bold_font = await pdfDoc.embedFont(genminchoBoldArrayBuffer);

  const [ height, width ] = PageSizes.A4

  const pageParameter = getHorizontalOrderFormPageParameter(width, height, {mincho_font, mincho_bold_font}, shops, destinations, shippingDateInfo, pdfSetting);
  let {shopSummary} = pageParameter  
  
  if (shopSummary) {
    outputOrderCheckFormForACycle(pdfDoc, marketPriceInfo, directorEmployeeInfo, priceInfoList, shippingDateInfo, pageParameter, shops)
  } else {
    shops.forEach((shopInfo) => {
      outputOrderCheckFormForACycle(pdfDoc, marketPriceInfo, directorEmployeeInfo, priceInfoList, shippingDateInfo, pageParameter, [shopInfo])
    })
  }

  pdfDoc.setCreator("丸伊伊那青果　事務担当");
  
  // 選択されたページに対する余計なページを削除
  const printPages = getPrintPages(pdfSetting.printPageStr, pdfDoc.getPageCount())

  const deletePages
    = Array.from(new Array(pdfDoc.getPageCount()))
      .map((_, pageIndex) => pageIndex)
      .filter((pageIndex) => !printPages.includes(pageIndex + 1))
      .reverse();

  deletePages.forEach((pageIndex) => {
    pdfDoc.removePage(pageIndex);
  })

  return [await pdfDoc.save()];

}
export async function createHorizontalOrderCheckFormPDF(
  marketPriceId, shops, destinations, isSample, shippingDateInfo, pdfSetting, marketPriceHistoryDate = null
) {
  let marketPriceResponse = await postMarketPriceSearchTableInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfo = marketPriceResponse.marketPriceTableInfoList[0];
  const directorEmployeeResponse = await getDirectorEmployee();
  const directorEmployeeInfo = directorEmployeeResponse.masterVarInfo.map((element) => ({
    directorEmployeeId: element.varCd,
    directorEmployeeName: element.varValue1,
  }));

  const orderShippingDateInfo = pdfSetting.datePartition ? shippingDateInfo : {shippingDateFrom: marketPriceHistoryDate, shippingDateTo: null};

  let res = await getListOrderDetail({
    marketPriceId,
    marketPriceHistoryDate, 
    orderDateFrom : orderShippingDateInfo.shippingDateFrom,
    orderDateTo : orderShippingDateInfo.shippingDateTo
  });

  let marketPriceInfoList = res.listOrderDetailInfo
              .filter((data) => data.isCustomerOrder)
              .map((data)=>({
                ...data,
                price: data.marketPrice,
                shopOrderInfo: data.shopOrderInfo.map((shopOrder) => ({
                  ...shopOrder,
                  orderQuantity : data.marketPriceHistoryDate == marketPriceHistoryDate ? stripTrailingZeros(shopOrder.orderQuantity) : 0
                })),
                sellingPriceMarkUpRate : data.sellingPriceMarkUpRate || marketPriceInfo.sellingPriceMarkUpRate,
                primePriceMarkUpRate: data.primePriceMarkUpRate || marketPriceInfo.primePriceMarkUpRate,
                deliveryPriceAdditionCd: marketPriceInfo.deliveryPriceAdditionCd,
                deliveryPriceAdditionAmount: marketPriceInfo.deliveryPriceAdditionAmount
              }));        

  return await createHorizontalOrderCheckFormPDFDocumentInfo(
    marketPriceInfo,
    directorEmployeeInfo,
    marketPriceInfoList,
    shops,
    destinations,
    isSample,
    orderShippingDateInfo,
    pdfSetting
  );
 
}

const getTitle = (asSendingLabel) => {
  return asSendingLabel ? "送り状" : "市況価格表";
}
